<template>
  <div
      :class="'sidebar '+ (sidebarCondition ? ' sidebar-active ' : ' ')"
      :data-color="activeColor"
      :data-image="backgroundImage"
      :data-background-color="backgroundColor"
      :style="sidebarStyle"
      @mouseover="hoverClassCondition = true"
      @mouseleave="hoverClassCondition = false">
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link">
            <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
      <ul class="md-list nav md-theme-default" style="bottom: 40px;position: absolute;width: 100%;">
        <li class="tm-sidebar-btn1" v-if="rolesWithManualSidebar.includes(role)">
          <a href="#" class="nav-link" @click="sidebarToggle = (!sidebarToggle)">
            <i class="md-icon md-icon-font md-theme-default">keyboard_double_arrow_right</i>
            <p>
              {{ local_page_keys.sidebar_menu_toggle }}
            </p>
          </a>
        </li>
        <li class="" :data-uk-tooltip="'title:' + local_page_keys.support_dropdown_message + '; pos: right; offset: -5;'">
          <a href="https://t.me/anastasia_melni4uk" target="_blank" class="nav-link">
            <i class="md-icon md-icon-font md-theme-default">contact_support</i>
            <p>
              {{ local_page_keys.sidebar_link_title }}
            </p>
<!--            <div class="uk-dropdown tm-dropdown tm-dropdown-top-left" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top-left; delay-hide: 400; delay-show: 0; offset: 5">-->
<!--              {{local_page_keys.support_dropdown_message}}-->
<!--            </div>-->
          </a>
        </li>
      </ul>
    </div>
<!--    <div class="tm-sidebar-btn" v-if="rolesWithManualSidebar.includes(role)">-->
<!--      <a href="#" @click="sidebarToggle = (!sidebarToggle)">-->
<!--        <i class="md-icon md-icon-font md-theme-default" style="color: #fff !important;">keyboard_double_arrow_right</i>-->
<!--      </a>-->
<!--    </div>-->
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: " "
    },
    rtlTitle: {
      type: String,
      default: "توقيت الإبداعية"
    },
    activeColor: {
      type: String,
      default: "green",
      validator: value => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: `${process.env.VUE_APP_BASE_URL}/img/sidebar-2.jpg`
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: `${process.env.VUE_APP_BASE_URL}/img/vue-logo.png`
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    local_page_keys: {},
    role: '',
    hoverClassCondition: false,
    sidebarToggle: false,
    rolesWithManualSidebar: ['senior-retoucher', 'pro-retoucher', 'retoucher', 'junior-retoucher', 'test-retoucher', 'admin', 'tester'],
  }),
  created() {
    this.$sidebar.toggleMinimize();
    this.getRole();
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    async getRole() {
      await this.$store.dispatch("profile/role");
      this.role = await this.$store.getters["profile/role"];
    },
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      };
    },
    sidebarCondition() {
      if (this.role && this.rolesWithManualSidebar.includes(this.role)) {
        return this.sidebarToggle;
      } else {
        return this.hoverClassCondition;
      }
    }
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('menu');
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
.tm-sidebar-btn {
  position: absolute;
  top: 50%;
  transform: translate(0,-50%);
  z-index: 3000;
  border-radius: 0 4px 4px 0;
  right: -44px;
  background-color: green;
}
.tm-sidebar-btn a {
  display: block;
  padding: 10px;
  transition: .1s ease-in-out;
}
.tm-sidebar-btn a i {
  opacity: 1;
}
.sidebar-active .tm-sidebar-btn1 i,
.sidebar-active .tm-sidebar-btn a {
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
